import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    DASHBOARD_USER_DATA,
    DASHBOARD_USER_DATA_SUCCESS
} from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
    type: API_SUCCESS,
    payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
    type: API_FAIL,
    payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
    type: GET_CHARTS_DATA,
    payload: periodType
});

export const initLoadUserData = (filter) => {
    return {
      type: DASHBOARD_USER_DATA,
      payload: filter,
    }
  }
  
  export const loadUserData  = user => {
    return {
      type: DASHBOARD_USER_DATA_SUCCESS,
      payload: user,
    }
  }
